function normalizeStudentStatus(status) {
  if (status == null || status === '') return ''
  return String(status).trim().toLowerCase().replace(/\s+/g, '_')
}

/** Students whose status is passed out (any common spelling / spacing). */
export function excludePassedOutStudents(studentList = []) {
  return studentList.filter(
    (student) => normalizeStudentStatus(student?.status) !== 'passed_out',
  )
}
